<template>
  <div class="collapse-item py-2" :class="{'is-active': isActive}">
    <div
      role="tab"
      :aria-expanded="isActive"
      :aria-controls="`collapse-content-${id}`"
      :aria-describedby="`collapse-content-${id}`"
    >
      <div
        class="collapse-item__header flex items-start font-bold lg:text-lg py-2 outline-none select-none transition-colors"
        @click="handleHeaderClick"
        role="button"
        :id="`collapse-head-${id}`"
        tabindex="0"
        @keyup.space.enter.stop="handleEnterClick"
        :class="{
          'focusing': focusing,
          'is-active text-primary-600': isActive
        }"
        @focus="handleFocus"
        @blur="focusing = false"
      >
        <slot name="title">{{title}}</slot>
        <div class="ml-auto p-0.5 pl-4">
          <svg :class="{'transform rotate-90': isActive}" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 transition" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>
    <app-collapse-transition
      v-on:after-enter="updateView"
      v-on:after-leave="updateView"
    >
      <div
        class="collapse-item__wrap"
        v-show="isActive"
        role="tabpanel"
        :aria-hidden="!isActive"
        :aria-labelledby="`collapse-head-${id}`"
        :id="`collapse-content-${id}`"
      >
        <div class="collapse-item__content">
          <slot></slot>
        </div>
      </div>
    </app-collapse-transition>
  </div>
</template>

<script>
import Emitter from './emitter'
export default {
  name: 'AppCollapseItem',
  componentName: 'AppCollapseItem',
  mixins: [Emitter],
  data () {
    return {
      contentWrapStyle: {
        height: 'auto',
        display: 'block'
      },
      contentHeight: 0,
      focusing: false,
      isClick: false
    }
  },
  inject: ['collapse'],
  props: {
    title: String,
    name: {
      type: [String, Number],
      default () {
        return this._uid
      }
    }
  },
  computed: {
    isActive () {
      return this.collapse.activeNames.indexOf(this.name) > -1
    },
    id () {
      return this.generateId()
    }
  },
  methods: {
    updateView () {
    //  this.$locomotive.update()
    },
    handleFocus () {
      setTimeout(() => {
        if (!this.isClick) {
          this.focusing = true
        } else {
          this.isClick = false
        }
      }, 50)
    },
    handleHeaderClick () {
      this.dispatch('AppCollapse', 'item-click', this)
      this.focusing = false
      this.isClick = true
    },
    handleEnterClick () {
      this.dispatch('AppCollapse', 'item-click', this)
    },
    generateId () {
      var d = new Date().getTime()
      if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now() // use high-precision timer if available
      }
      var newGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
      return newGuid
    }
  }
}
</script>
